import { lazy } from 'react';

// project import
import MainLayout from 'layout/MainLayout';
import CommonLayout from 'layout/CommonLayout';
import AuthGuard from 'utils/route-guard/AuthGuard';
import Loadable from 'components/Loadable';
import ProductPage from 'pages/product-page';
import ProjectPage from 'pages/project-page';
import Home from 'pages/home';
import ModuleLayout from 'pages/module/module-layout';
import ModuleLayoutDetails from 'pages/module/module-layout-details';
import ModuleLayoutBatchUpdate from 'pages/module/module-layout-batch-update';
import UserProfile from 'pages/user/profile';
import UserAdmin from 'pages/userAdmin';
import Summary from 'pages/report/summary';
import AccurarcyAlertReport from 'pages/report/accurarcyAlertReport';
import SettingLayout from 'pages/setting/setting-layout';
import RealtimeMapGps from 'pages/map/realtime_map_gps';
import SettingImport from 'pages/setting/setting-import';
import Support from 'pages/user/support';
import Login from 'pages/auth/login';
import AppDeviceVersionList from 'pages/app/appDeviceVersion';
// import Drawing from 'pages/drawing';

// pages routing
const MaintenanceError = Loadable(lazy(() => import('pages/maintenance/404')));
const MaintenanceError500 = Loadable(lazy(() => import('pages/maintenance/500')));
const MaintenanceUnderConstruction = Loadable(lazy(() => import('pages/maintenance/under-construction')));
const MaintenanceComingSoon = Loadable(lazy(() => import('pages/maintenance/coming-soon')));

// render - sample page
const SamplePage = Loadable(lazy(() => import('pages/extra-pages/sample-page')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: (
        <AuthGuard>
          <MainLayout />
        </AuthGuard>
      ),
      children: [
        {
          path: '/',
          element: <ProductPage />
        },
        {
          path: '/dashboard',
          element: <Home />
        },
        {
          path: '/profile',
          element: <UserProfile />
        },
        {
          path: '/support',
          element: <Support />
        },

        {
          path: '/setting/:type',
          element: <SettingLayout />
        },
        {
          path: '/setting/:type/import',
          element: <SettingImport />
        },
        {
          path: '/bc/:type',
          element: <ModuleLayout />
        },
        {
          path: '/bc/:type/detail',
          element: <ModuleLayoutDetails />
        },
        {
          path: '/bc/:type/batchUpdate',
          element: <ModuleLayoutBatchUpdate />
        },

        {
          path: '/project',
          element: <ProjectPage />
        },

        {
          path: '/functions/realtimeMapGps',
          element: <RealtimeMapGps />
        },
        {
          path: '/report/summary',
          element: <Summary />
        },
        {
          path: '/report/dataAccuracyAlert',
          element: <AccurarcyAlertReport />
        },

        {
          path: '/userAdmin',
          element: <UserAdmin />
        },
        {
          path: '/appadmin/appDeviceVersion',
          element: <AppDeviceVersionList />
        },

        {
          path: '/product',
          element: <ProductPage />
        }
      ]
    },
    {
      path: '/maintenance',
      element: <CommonLayout />,
      children: [
        {
          path: '404',
          element: <MaintenanceError />
        },
        {
          path: '500',
          element: <MaintenanceError500 />
        },
        {
          path: 'under-construction',
          element: <MaintenanceUnderConstruction />
        },
        {
          path: 'coming-soon',
          element: <MaintenanceComingSoon />
        }
      ]
    },
    {
      path: '*',
      element: <MaintenanceError />
    }
  ]
};

export default MainRoutes;
